/* 倒入 api */
import axios from '@/utils/ajax/index';

/* 导出文件 api */
import fileExport from '@/utils/fileExport/index';


/* 诊所列表 */
export const chainHospital = (data) => {
  return axios({
    url: '/chain/chainHospitalList',
    method: 'post',
    data,
  });
};

/* 查询连锁诊所此账号下所有诊所信息 */
export const hospitals = (params) => {
  return axios({
    url: '/chain/hospitals',
    method: 'get',
    params,
    hideLoading: true,
  });
};

/* 获取账号的创建诊所的等级的信息 */
export const accountRoleInfo = (params) => {
  return axios({
    url: '/chain/accountRoleInfo',
    method: 'get',
    params,
  });
};

/* 新增连锁诊所 */
export const addChainHospital = (data) => {
  return axios({
    url: '/chain/chainHospital',
    method: 'post',
    data,
  });
};

/* 诊所详情 */
export const chainHospitalDetail = (params) => {
  return axios({
    url: `/chain/chainHospital/${params.hospitalId}`,
    method: 'get',
    params,
  });
};

/* 更新诊所详情 */
export const updateChainHospital = (data) => {
  return axios({
    url: `/chain/chainHospital/${data.hospitalId}`,
    method: 'put',
    data,
  });
};

/* 查询所有连锁诊所部门树 */
export const getClinicDepartmentTree = (params) => {
  return axios({
    url: '/chain/getClinicDepartmentTree',
    method: 'get',
    params,
  });
};

/* 查询所有普通诊所部门树 */
export const getOrdinaryDepartmentTree = (params) => {
  return axios({
    url: '/chain/getOrdinaryDepartmentTree',
    method: 'get',
    params,
  });
};

// 管理员页面查看所发布的消息的列表
export const listMessage = (data) => {
  return axios({
    url: '/system/message/listMessage',
    method: 'post',
    data,
  });
};

// 生成消息模板
export const generate = (data) => {
  return axios({
    url: '/system/message/generate',
    method: 'post',
    data,
  });
};

// 管理员 或者连锁诊所管理员 删除信息
export const delMessage = (data) => {
  return axios({
    url: `/system/message/${data.id}`,
    method: 'delete',
    data,
  });
};

// 管理员 或者连锁诊所管理员 修改信息
export const updateMessage = (data) => {
  return axios({
    url: `/system/message/${data.id}`,
    method: 'put',
    data,
  });
};

// 管理员 或者连锁诊所管理员 查看消息详情
export const getMessageDetail = (params) => {
  return axios({
    url: `/system/message/${params.id}`,
    method: 'get',
    params,
  });
};

// 申请注册诊所列表
export const registedHospital = (params) => {
  return axios({
    url: '/registedHospital',
    method: 'get',
    params,
  });
};

// 申请诊所注册的详情
export const registedHospitalDetail = (params) => {
  return axios({
    url: `/registedHospital/detail/${params.id}`,
    method: 'get',
    params,
  });
};

// 更新申请诊所备注
export const updateRegistedHospital = (data) => {
  return axios({
    url: `/registedHospital/${data.id}`,
    method: 'put',
    data,
  });
};

// 申请注册诊所列表导出
export const registedHospitalExport = (params) => {
  const path = '/registedHospital/excel';
  fileExport(path, params);
};

// 连锁诊所列表导出
export const chainHospitalListExport = (params) => {
  const path = '/chain/chainHospitalList/excel';
  fileExport(path, params);
};

export default {
  chainHospital,
  hospitals,
  accountRoleInfo,
  addChainHospital,
  chainHospitalDetail,
  updateChainHospital,
  getClinicDepartmentTree,
  getOrdinaryDepartmentTree,
  listMessage,
  generate,
  delMessage,
  getMessageDetail,
  updateMessage,
  registedHospital,
  registedHospitalDetail,
  updateRegistedHospital,
  registedHospitalExport,
  chainHospitalListExport,
};
